var RecaptchaSize;
(function (RecaptchaSize) {
    RecaptchaSize["COMPACT"] = "compact";
    RecaptchaSize["NORMAL"] = "normal";
})(RecaptchaSize || (RecaptchaSize = {}));
var RecaptchaVersion;
(function (RecaptchaVersion) {
    RecaptchaVersion["V2"] = "V2";
    RecaptchaVersion["V3"] = "V3";
})(RecaptchaVersion || (RecaptchaVersion = {}));
export { RecaptchaSize, RecaptchaVersion, };
//# sourceMappingURL=recaptcha-constants.js.map